(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dk-featured-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.dateckHomepageSlotTracking) return;
  window.dateckHomepageSlotTracking = true;
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {});
  }
  document.addEventListener('click', function (event) {
    if (event.target.closest('button')) return;
    var link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented) return;
    var slot = link.closest('[data-homepage-slot]');
    if (!slot) return;
    var shopify = window.Shopify;
    if (!shopify || !shopify.customerPrivacy || typeof shopify.customerPrivacy.analyticsProcessingAllowed !== 'function') return;
    if (!shopify.customerPrivacy.analyticsProcessingAllowed()) return;
    var url;
    try { url = new URL(link.href, window.location.origin); } catch (error) { return; }
    if (url.origin !== window.location.origin) return;
    var data = {
      placement: slot.dataset.homepageSlot,
      destination: url.pathname,
      source_tab: slot.dataset.sourceTab,
      page_type: 'homepage'
    };
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'homepage_slot_click', Object.assign({ send_to: 'G-J8D5DDQ189', transport_type: 'beacon' }, data));
    } else if (shopify.analytics && typeof shopify.analytics.publish === 'function') {
      Promise.resolve(shopify.analytics.publish('dateck:homepage_slot_click', data)).catch(function () {});
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:request', async (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      return; 
    }

    // Cancel default cart addition processing
    event.preventDefault();

    try {
      // Convert FormData to array format (expected by AddToCartFlyout)
      const formData = event.detail.form;
      const formDataArray = [];
      for (let [key, value] of formData.entries()) {
        formDataArray.push({ name: key, value: value });
      }

      const submitButton = document.querySelector('button[type="submit"], input[type="submit"]');
      
        const addToCartFlyout = new window.AddToCartFlyout(formDataArray, {
          atcButton: submitButton,
          settings: {
            moneyFormat: window.SHOP_MONEY_FORMAT
          }
        });

        // Wait for AddToCartFlyout completion and return actual response data
        const handleComplete = (completeEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.resolve(completeEvent.detail.responseData);
        };

        const handleError = (errorEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.reject(errorEvent.detail.error);
        };

        document.addEventListener('addToCartFlyout:complete', handleComplete);
        document.addEventListener('addToCartFlyout:error', handleError);

    } catch (error) {
      console.error('AddToCartFlyout error:', error);
      event.detail.reject(error);
    }
  });

  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = window.Theme.routes.cart_url;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
